module.exports = __webpack_public_path__ + "img/image7.25795b36.png";